import React, { lazy, Suspense } from "react";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import LoginAsUser from "../../components/loginasuser/LoginAsUser";
import { commonText, smsTemplate } from "../../locales/en";
import ComponentViewFallback from "../../components/error-boundary/fallback/ComponentViewFallback";
import ErrorBoundary from "../../components/error-boundary";
const SMSTemplateTable = lazy(
  () =>
    import(
      "../../components/table/all-tables/smstemplatetable/SMSTemplateTable"
    )
);

export default function SmsTemplate() {
  return (
    <>
      <LoginAsUser />
      <TablePagesTitle mainTitle={smsTemplate.mainTitle} />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mt-4 mb-2 mx-0">
          <div className="col-md-12 px-0">
            <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
              <SMSTemplateTable />
            </Suspense>
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
}
